import config from '@/config'

export default {
  user_status: {
    NEW: "New user, but not yet verified",
    ACTIVE: "Active user",
    RESET: "User password has been reset",
    ATTEMPT_BLOCK: "User blocked due to 3 failed login attempts",
    COMPANY_BLOCK: "User blocked by company",
    SUSPEND: "User suspend"
  },

  login: "Sign In to your account",
  relogin: "Please re-login to your account again.",
  expired: "Session Expired!",
  denied: "Permission Denied!",
  success: "SUCCESS",
  search_by_id: "Search by ID",
  search_by_full_id: "Search by full ID",
  successful_change_password: "You have successfully change password.",
  select_option: "Select your option",
  no_data_available: "No Data Available",
  no_rating_available: "No Rating Available",
  successful_update_security: "You have successfully update security.",
  successful_disable_security: "You have successfully disable security.",
  update_security_confirm: "Are you sure you want to update security?",
  disable_security_confirm: "Are you sure you want to disable security?",
  change_operator_status_confirm: "Are you sure you want to change operator \"{name}\" status?",
  change_member_status_confirm: "Are you sure you want to change member \"{name}\" status?",
  change_bank_account_status_confirm: "Are you sure want to change \"{name}\" account status?",
  change_promotion_seq_confirm: "Are you sure want to change \"{id}\" sequence?",
  change_promo_status_confirm: "Are you sure want to change \"{name}\" promotion status?",
  change_promo_signup_status_confirm: "Are you sure want to change \"{name}\" promotion signup status?",
  successful_update_account_setup: "You have successfully update account setup.",
  unblock_member_confirm: "Are you sure you want to unblock member \"{name}\"?",
  unblock_operator_confirm: "Are you sure you want to unblock operator \"{name}\"?",
  block_sub_account_confirm: "Are you sure you want to block sub account \"{name}\"?",
  unblock_sub_account_confirm: "Are you sure you want to unblock sub account \"{name}\"?",
  successful_create_secondary_account: "You have successfully create secondary account.",
  successful_update_account_password: "You have successfully update account password.",
  update_account_password_cancel: "Are you sure you want to cancel update account password?",
  change_affiliate_status_confirm: "Are you sure you want to change affiliate \"{name}\" status?",
  unblock_affiliate_confirm: "Are you sure you want to unblock affiliate \"{name}\"?",
  change_coupon_status_confirm: "Are you sure want to change \"{name}\" coupon status?",
  submit_acknowledgement_confirm: "Are you sure want to submit acknowledgement?",
  change_bank_group_default_confirm: "Are you sure want to set \"{name}\" as default bank group?",
  change_withdrawal_limit_default_confirm: "Are you sure want to set \"{name}\" as default withdrawal limit?",
  change_promotion_group_default_confirm: "Are you sure want to set \"{name}\" as default promotion group?",
  change_referral_status_confirm: "Are you sure you want to change \"{name}\" referral status?",
  change_withdrawal_limit_confirm: "Are you sure you want to change \"{name}\" withdrawal limit?",
  change_promotion_group_confirm: "Are you sure you want to change \"{name}\" promotion group?",
  change_bank_group_confirm: "Are you sure you want to change \"{name}\" bank group?",
  change_member_bet_limit_confirm: "Are you sure you want to change \"{name}\" \"{provider}\" bet limit?",
  assign_free_credit_confirm: "Are you sure want to assign free credit to \"{name}\"?",
  update_survey_status_confirm: "Are you sure you want to update survey status?",
  move_banner_up_confirm: "Are you sure want to move banner \"{name}\" up?",
  move_banner_down_confirm: "Are you sure want to move banner \"{name}\" down?",
  delete_banner_confirm: "Are you sure want to delete banner \"{name}\"?",
  change_banner_status_confirm: "Are you sure you want to change banner \"{name}\" status?",
  delete_page_confirm: "Are you sure want to delete page \"{name}\"?",
  change_page_status_confirm: "Are you sure you want to change page \"{name}\" status?",
  clear_maintenance_time_confirm: "Are you sure want to clear \"{name}\" maintenance time?",
  successful_clear_outstanding: "You have successfully clear {amt} outstanding amount.",
  clear_outstanding_confirm: "Are you sure want to clear \"{name}\" outstanding?",
  trace_outstanding_confirm: "Are you sure want to trace \"{name}\" outstanding?",
  change_setting_confirm: "Are you sure want to change \"{name}\" setting?",
  add_bonus_list_member_confirm: "Are you sure want to add selected member to bonus list?",
  delete_bonus_list_member_confirm: "Are you sure want to delete selected member from bonus list?",
  delete_ip_address_confirm: "Are you sure want to delete ip \"{ip}\" under \"{name}\"?",
  add_ip_address_confirm: "Are you sure want to add ip \"{ip}\" under \"{name}\"?",
  change_payment_mode_status_confirm: "Are you sure want to change \"{name}\" payment mode status?",
  change_provider_group_status_confirm: "Are you sure want to change \"{group}\" status under \"{mode}\"?",
  bulk_issue_bonus_member_confirm: "Are you sure want to issue bonus to members in bonus list?",
  change_provider_group_recommend_confirm: "Are you sure want to change \"{group}\" recommend under \"{mode}\"?",
  change_provider_group_seq_confirm: "Are you sure want to change \"{group}\" sequence under \"{mode}\"?",
  no_member_found: "No Member Found",
  redeposit_ticket_confirm: "Are you sure want to redeposit ticket?",
  change_provider_group_limit_confirm: "Are you sure want to change \"{group}\" limit under \"{mode}\"?",
  audit_ticket_confirm: "Are you sure you want to audit the ticket?",
  review_ticket_confirm: "Are you sure you want to review the ticket?",
  change_promotion_group_seq_confirm: "Are you sure want to change \"{promotion}\" sequence under \"{group}\"?",
  unlock_custom_vip_confirm: "Are you sure want to unlock \"{name}\" custom vip?",
  move_affiliate_confirm: "Are you sure want to move whole branch of \"{name}\" direct under \"{operator}\"?",
  cancel_unfinish_round_confirm: "Are you sure want to cancel unfinish round \"{round}\"?",
  change_payment_mode_seq_confirm: "Are you sure want to change \"{mode}\" sequence?",
  remove_bank_default_provider_confirm: "Are you sure want to remove \"{bank}\" default provider?",
  change_label_status_confirm: "Are you sure want to change \"{name}\" label status?",
  clear_iframe_url_confirm: "Are you sure want to clear iframe url?",
  delete_turnover_tier_confirm: "Are you sure want to delete \"{name}\" turnover tier?",
  vip_provider_rebate_batch_confirm: "Are you confirm to proceed with vip provider rebate batch update?",
  copy_rebate_rate_all_confirm: "Are you sure want to copy \"{name}\" of \"{provider}\" to all providers?",
  edit_vip_confirm: "Are you want to update rebate rate of \"{name}\"?",
  add_promotion_custom_member_confirm: "Are you want to add promotion custom member list?",
  delete_promotion_custom_member_confirm: "Add you want to delete \"{name}\" promotion custom member list?",
  change_rescue_fund_status_confirm: "Are you sure want to change \"{name}\" rescue fund status?",
  add_rescue_fund_custom_member_confirm: "Are you want to add rescue fund custom member list?",
  delete_rescue_fund_custom_member_confirm: "Add you want to delete \"{name}\" rescue_fund custom member list?",
  change_ads_status_confirm: "Are you sure want to change \"{name}\" advertisement status?",
  adjust_amount_bank_tooltip: "Support minus sign (-) to deduct balance from bank account balance",
  adjust_amount_operator_tooltip: "Support minus sign (-) to deduct balance from operator wallet",
  adjust_amount_member_tooltip: "Support minus sign (-) to deduct balance from member balance",
  purchase_domain_tooltips: "Congratulations!! Wish your dream will be fulfilled!",
  change_provider_game_seq_confirm: "Are you sure want to change \"{mode}\" sequence?",
  purchase_domain_confirm: "Are you sure want to purchase \"{name}\" domain?",
  search_by_domain_name: "Search By Domain Name",
  search_by_domain_status: "Search By Domain Status",
  search_by_account_id: "Search By Account ID",
  search_by_operator_id: "Search By Operator ID",
  search_by_full_name: "Search By Full Name",
  search_by_contact_phone: "Search By Contact Phone",
  search_by_signup_ip: "Search By Sign Up IP",
  search_by_referral_code: "Search By Referral Code",
  search_by_bank_acc_no: "Search By Bank Acc No",
  search_by_affiliate_code: "Search By Affiliate Code",
  info1: "1. Subdomain is not allowed",
  info2: "2. Does not require 'https://' or 'http://'",
  info3: "3. Example: abc.com",
  move_announcement_banner: "Re-sequence banner",
  atLeastOneChecked: "At least one threshold need to be checked",
  adjustWalletTooltips: "Support minus sign (-) to deduct balance from affiliate wallet",
  emailOTPTooltips: "Email OTP will be expired in 3 minutes after request",
  domain_status_update_confirm: "Are you want to update \"{name}\" status?",
  delete_access_control_confirm: "Are you sure want to remove \"{name}\"?",
  delete_access_control_success: "You have successfully remove \"{name}\".",
  add_access_control_confirm: "Are you sure want to add access control?",
  add_access_control_success: "You have successfully add access control.",
  delete_access_auto_confirm: "Are you sure want to remove \"{name}\"?",
  delete_access_auto_success: "You have successfully remove \"{name}\".",
  add_access_auto_confirm: "Are you sure want to add into auto assign?",
  add_access_auto_success: "You have successfully add into auto assign.",
  move_banner_confirm: "Are you sure want to change \"{name}\" to position \"{position}\"?",
  delete_game_exclude_confirm: "Are you sure want to delete \"{name}\"?",
  banner_size_tooltips: "Please follow the allowed image size dimension: \"{size}\".",
  purchase_domain_success: "Purchase domain successfully!",
  purchase_domain_failed: "Purchase domain failed!",
  apply_domain_success: "Apply domain successfully!",
  apply_domain_failed: "Apply domain failed!",
  tooltips_pnl: "Platform winlose x Platform PT % = Total Earning",
  delete_package_confirm: "Are you sure want to delete \"{package}\" package?",
  search_by_lang_code: "Search by Language Code",
  pleaseSelectAnImage: "Please Select an Image",
  pleaseSelectAValidImageType: "Please Select a Valid Image Type",
  imageTooLargeMaxSizeAllowedIsOneMb: "Image too large, max size allowed is 1MB",
  uploadYourLogoWithPngOrJpegFormat: "Upload your logo with png or jpeg format",
  allowedPngAndJpegOnlyMaxOneMb: "Allowed png and jpeg only (Image size max 1MB)",
  delete_theme_content_confirm: "Are you sure want to delete \"{themecontent}\" theme content?",
  delete_theme_confirm: "Are you sure want to delete \"{theme}\" theme?",
  delete_color_confirm: "Are you sure want to delete \"{color}\" color?",
  delete_content_confirm: "Are you sure want to delete \"{content}\" content?",
  reset_password_confirm: "Are you sure want to reset password for \"{userid}\"?",
  block_account_confirm: "Are you sure want to block \"{userid}\"?",
  suspend_account_confirm: "Are you sure want to suspend \"{userid}\"?",
  active_account_confirm: "Are you sure want to active \"{userid}\"?",
  temporaryPasswordFor: "Temporary password for \"{name}\" is ",
  needAiToGenerateLogo: "Need AI to generate logo",
  delete_domain_confirm: "Are you sure want to delete \"{domain}\" domain?",
  previewImageForIllustrationOnly: "Preview images shown are for illustration purpose only.",
  actualResultMayVary: "Actual result may vary due to website enhancement.",
  chooseYourPreferedResponsiveLayoutTheme: "Choose your prefered responsive layout theme",
  chooseYourPreferedColor: "Choose your prefered Color",
  please_update_provider_before_edit_game: "Please update provider before editing game",
  delete_theme_content_group_confirm: "Are you sure want to delete \"{themecontentgroup}\" theme content group?",
  phoneFormat: "e.g. +63XXXXXXXXXX",
  change_theme_will_replace_menu: "Are you sure you want to update theme? (Change theme will cause Menu to be replaced)",
  change_provider_seq_confirm: "Are you sure want to change \"{provider}\" sequence?",
  change_provider_status_confirm: "Are you sure want to change \"{provider}\" provider status?",
  actionPerformWillReflectProd: "* Any action perform here will direct reflect to Production",
  site_sync_confirm: "Are you sure you want to sync to the Production?",
  clear_profile_setting_maintenance_confirm: "Are you sure want to clear maintenance?",
  change_social_platform_status_confirm: "Are you sure want to change \"{name}\" social platform status?",
  search_by_site_name: "Search By Site Name",
  change_social_account_status_confirm: "Are you sure want to change \"{name}\" social account status?",
  themeMenuMessage1: "* Rerrange the menu order by drag and drop the menu item",
  themeMenuMessage2: "* Uncheck the check box if wish to hide the menu item",
  search_by_operator: "Search By Operator",
  search_by_ticket: "Search By Ticket",
  search_member: "Search Member",
  site_recreate_confirm: "Are you sure want to recreate site \"{name}\"?",
  search_by_game_type: "Search By Game Type",
  total_not_count_by_date_range: "This total is not counted by date range",
  tooltips_upload_size: "Uploaded file size cannot be exceed 1mb.",
  tooltips_href: "Href field required the extension of domain. Eg: 'yourwebsite.com/promotions', fill in 'promotions' will do.",
  d_winlose_chart: "Visualize win/loss and withdrawal trends.",
  d_turnover_chart: "Analyze turnover and deposit trends.",
  d_deposit: "Shows deposit count and unique members.",
  d_withdrawal: "Displays total withdrawal transactions.",
  d_active_player: "Total bets and unique logins by players.",
  d_winlose: "Displays net win/loss totals.",
  d_turnover: "Total turnover generated.",
  d_member: "Count of all registered members.",
  d_referee: "Total number of user referrals.",
  d_verfied_signup: "Counts of verified users and new signups.",
  d_ftd: "Number and amount of first-time deposits.",
  d_top_winner: "Player ID and total win amount.",
  d_top_loser: "Player ID and total loss amount.",
  d_top_deposit: "Player ID and total deposit amount from most to least.",
  d_top_withdrawal: "Player ID and total withdrawal amount from most to least.",
  d_top_promotion: "Rank, promotion ID, name, and claims by players.",
  d_payment_gateway: "Rank, method, vendor, processed, rejected, total, and success rate through gateways.",
  tooltips_promo_member_custom: "Please put in multiple member id with comman separators. Eg: member001,member002,member003",
  tooltips_social_facebook: "Eg: https://www.facebook.com/",
  tooltips_social_instagram: "Eg: https://www.instagram.com/",
  tooltips_social_skype: "Eg: skype:<username>?chat",
  tooltips_social_telegram: "Eg: https://t.me/<ID>",
  tooltips_social_tiktok: "Eg: https://www.tiktok.com/<ID>",
  tooltips_social_wechat: "Eg: <ID>",
  tooltips_social_whatsapp: "Eg: https://wa.me/<ID>",
  tooltips_social_youtube: "Eg: https://www.youtube.com/<ID>",
  search_by_business_id: "Search By Business ID",
  ticket_taken_confirm: "Are you sure want to take control on this ticket id \"{name}\"?",
  tooltips_payment_setting: "The below will only be reflected if 'Settings' - 'Payment Setting' is set to 'OWN'",
  tooltips_cms_announcement_main: "Maximum 5 announcement banners for best user experience",
  tooltips_cms_announcement_title: "Maximum 25 characters for best user experience",
  tooltips_cms_announcement_body: "Maximum 200 characters, 40 characters per row for best user experience",
  delete_livechat_confirm: "Are you sure want to delete live chat?",
  tooltips_vip_name: "Maximum 10 characters for best user experience",
  tooltips_sequence: "The smaller the number of sequence, the higher the game priority will be.",
  tooltips_turnover: "Member's Turnover",
  tooltips_rebate_rate: "Member's Rebate Rate %",
  tooltips_promo_bonus_rate: "Recommended at 100%. Any excess beyond 100% will be the operator's responsibility.",
  tooltips_promo_signup: "Recommended between AUD1- AUD20. Any excess beyond AUD1- AUD20 will be the operator's responsibility.",
  tooltips_bonus_issue: "Recommended between AUD1-AUD1000. Any excess beyond AUD1- AUD1000 will be the operator's responsibility.",
  tooltips_vip_cycle_day: "The VIP cycle is measured in days.",
  vip_info1: "VIP level once created only can edit, cannot be deleted.",
  // total_not_count_by_date_range
  website_launched: "Shows total websites launched, total websites to date, total operators, and active sites today.",
  new_player_verified_signup: "Shows new player count, total active players, and total players up to the selected date.",
  depo_withdrawal_diff: "Shows the difference between total deposit and withdrawal amounts, deposit details, and withdrawal details.",
  bonus: "Shows total bonus amount claimed and total claim success count.",
  ggr: "Shows total Gross Gaming Revenue and total member balances for the selected date.",
  turnover: "Shows total turnover and current RTP percentage up to the selected date.",
  provider_pt_on_global_confirm: "Are you sure you want to update provider \"{name}\" PT's criteria?",

  approve_affiliate_ticket_confirm: "Are you sure you want to approve the affiliate ticket?",
  change_payment_option_recommend_confirm: "Are you sure want to change \"{group}\" recommend under \"{mode}\"?",

  choosePackage: "Choose Package",
  effortlessCreate: "Effortlessly create, optimize, and manage your website! ",
  raiseNewHeight: "Raising you to new heights",
  fastSecureStable: "Fast, Secure, and Stable",
  realTimeData: "Real-Time Data Insights",
  highLevelTechTeam: "High-Level Technical Team!",
  strategicEmpowerment: "Strategic Empowerment!",
  supportFirst: " 24/7 support puts you first with personalized solutions!",
  empowermentBusiness: "Empowerment via Executive package achieve business goals!",
  pleaseFillUpSiteDetails: "Please fill up your site details",
  reviewYourOptionsAndCheckout: "Review your options and continue to checkout",
  chooseYourPreferedResponsiveLayoutTheme: "Choose your prefered responsive layout theme",
  chooseYourPreferedColor: "Choose your prefered color",
  pleaseSelectTheme: "Please Select Theme",
  pleaseSelectColor: "Please Select Color",
  websiteLayoutAndThemeDesign: "Website Layout and Theme Design ",
  operatorAccCreatedSuccessful: "Operator Account Created Successful",
  delete_default_template_confirm: "Are you sure want to delete \"{template}\" mini game template?",
  search_by_template_code: "Search by Template Code",
  delete_mini_game_confirm: "Are you sure want to delete \"{minigame}\" mini game?",
  delete_mini_game_template_confirm: "Are you sure want to delete \"{minigametemplate}\" mini game template?",
  delete_reward_confirm: "Are you sure want to delete \"{reward}\" reward?",
  search_by_game_name: "Search by Game Name",
  tooltips_gamereward: "Limit: {max}",
  change_gamify_status_confirm: "Are you sure want to change \"{gamify}\" reward status?",
  change_gamify_login_status_confirm: "Are you sure want to change \"{gamify}\" reward login status?",
  change_gamify_daily_login_status_confirm: "Are you sure want to change Daily Check-in (Daily Login) reward status?",
  change_partner_seq_confirm: "Are you sure want to change \"{id}\" sequence?",
  tooltips_partners_link: "Eg: https://www.google.com/",
  delete_partner_confirm: "Are you sure want to delete partner \"{name}\"?",
};
